/* src/app/admin-dashboard/site-system/records/actions-log/actions-log.css */
/*# sourceMappingURL=actions-log.css.map */
